import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {moduleConfig} from "../config";
import {GenerateCustomersButton} from '../../test-data-generator/buttons/GenerateCustomersButton.tsx';
import { CustomerStatus } from '../types';

interface IndexPageHeaderProps {
    onFilterChange: (status: CustomerStatus | null) => void;
}

const useTools = (onFilterChange: (status: CustomerStatus | null) => void) => {
    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    tools.push(<FilterRecordsButton key='filter' onFilterChange={onFilterChange} />);
    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes(rbacActions.DeleteCustomer)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateCustomer)) {
        tools.push(<AddRecordButton key='add'/>);
        tools.push(<GenerateCustomersButton key='generate'/>);
    }

    return tools;
};

export const IndexPageHeader = ({ onFilterChange }: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get(moduleConfig.titles.singular)}
            tools={useTools(onFilterChange)}
        />
    );
};